class BackButtonService {
    constructor() {
        this.handleBackButton = null;
        this.handlePopState = this.handlePopState.bind(this);
        this.isModalOpen = false;
        this.isSubmodalOpen = false;
        this.isDockOpen = false;
        this.isHandlingPopState = false;
        this.onCloseDock = null;
        this.ignoreNextPopState = false;
    }

    setOnCloseDockHandler(onCloseDock) {
        this.onCloseDock = onCloseDock;
    }

    addToHistory(stateName) {
        window.history.pushState(stateName, null, new URL(window.location.href));
        if (stateName === 'modal') {
            this.isModalOpen = true;
            this.isSubmodalOpen = false;
        } else if (stateName === 'submodal') {
            this.isSubmodalOpen = true;
        } else if (stateName === 'dock') {
            this.isDockOpen = true;
        }
        if (document.activeElement) {
            document.activeElement.blur();
        }
        document.body.focus();
    }

    addBackButtonListener(handleBackButton) {
        this.handleBackButton = handleBackButton;
        if (!this.isModalOpen && !this.isHandlingPopState) {
            this.addToHistory('modal');
        }
        window.removeEventListener('popstate', this.handlePopState);
        window.addEventListener('popstate', this.handlePopState);
    }

    addBackButtonListenerWithoutCheckingPopStateHandler(stateName, handleBackButton) {
        this.handleBackButton = handleBackButton;
        this.addToHistory(stateName);
        window.removeEventListener('popstate', this.handlePopState);
        window.addEventListener('popstate', this.handlePopState);
    }

    addBackButtonListenerOnly() {
        window.removeEventListener('popstate', this.handlePopState);
        window.addEventListener('popstate', this.handlePopState);
    }

    removeBackButtonListener() {
        window.removeEventListener('popstate', this.handlePopState);
        this.isSubmodalOpen = false;
        this.isModalOpen = false;
        this.isDockOpen = false;
    }

    handlePopState() {
        if (this.isHandlingPopState) {
            return;
        }
        this.isHandlingPopState = true;
        if (this.handleBackButton && !this.ignoreNextPopState) {
            this.handleBackButton();
        }
        if (!this.isModalOpen && !this.isSubmodalOpen) {
            this.isDockOpen = false;
            if (this.onCloseDock && !this.ignoreNextPopState) {
                this.onCloseDock();
            }
        }
        if (!this.isSubmodalOpen) {
            this.isModalOpen = false;
        }
        this.isSubmodalOpen = false;
        if (this.ignoreNextPopState) {
            this.ignoreNextPopState = false;
        }
        this.isHandlingPopState = false;
    }

    // Ako korisnik npr. zatvori modal klikom na X (umjesto back botunom), moramo taj modal ručno izbrisati iz povijesti.
    popStateWithoutTriggeringEvent() {
        this.ignoreNextPopState = true;
        window.history.back();
    }
}

export default new BackButtonService();
